import React, { useState } from 'react';
import { Radio } from 'antd';

const RadioItem = () => {
  const [value, setValue] = useState(1);
  const onChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <>
    <label htmlFor="radio-items" style={{marginBottom: "20px"}}> Graph Type (Secondary):</label>
    <Radio.Group onChange={onChange} value={value} id="radio-items">
      <Radio value={1} style={{color:"#fff"}}>Line</Radio>
      <Radio value={2} style={{color:"#fff"}}>Bar</Radio>
    </Radio.Group>
    </>
  );
};
export default RadioItem;